import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { StateClear, StateReset } from 'ngxs-reset-plugin';
import { ContractDisplayedState } from '../../states/contract-displayed.state';
import { STATES_WITH_RESET_IN_HOME } from '../constants/states-with-reset-in-home';

@Injectable({
  providedIn: 'root'
})
export class CustomClearStatesService {

  constructor(private store: Store) { }

  stateClear() {
    this.store.dispatch(
      new StateClear(ContractDisplayedState)
    );
  }

	resetStore() {
		this.store.dispatch(
			new StateReset(...STATES_WITH_RESET_IN_HOME)
		);
	}
}